// @core/api/endpoints/secret/mount_engine.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MountEngineRequest,
  SecretEngineResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Mount secrets engine
 * Mounts a new secrets engine at the specified path. Engine type determines available operations (KV, Transit, PKI, Database). Each engine is isolated with its own data and configuration.
 */
export async function MountEngine(
  data: MountEngineRequest,
  options?: RequestOptions
): Promise<SecretEngineResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/engines`;
  const requestOptions = options;
  return client.post<SecretEngineResponse>(requestPath, data, requestOptions);
}
